// NEW: UI_REVAMP
import { Button, Flex } from '@chakra-ui/react';

const OptionTabList = ({ options = [], activeValue, onChange, children, ...props }) => {
	return (
		<Flex flexWrap={{ base: 'wrap', lg: 'nowrap' }} {...props}>
			{options.map((item) => {
				const isActive = activeValue === item.value;
				const color = isActive ? 'white' : 'black';
				const bg = isActive
					? 'radial-gradient(38.76% 24.51% at 12.27% 4.5%, rgba(235, 235, 235, 0.70) 0%, rgba(235, 235, 235, 0.00) 100%), radial-gradient(66.66% 73.5% at 50% 100%, #E72F69 0%, #EA4C76 100%)'
					: 'white';
				return (
					<Button
						key={item.value}
						onClick={() => onChange?.(item.value)}
						flex={{ base: '0 0 calc(33.33% - 6px)', lg: '1' }}
						display='flex'
						justifyContent='center'
						alignItems='center'
						p={2.5}
						rounded={8}
						height={10}
						gap={2.5}
						color={color}
						borderWidth={1}
						bg={bg}
						borderColor={isActive ? '#EF7484' : '#F0F0F0'}
						blendMode={isActive ? 'lighten, normal' : ''}
						transition='none'
						transform='none'
						boxShadow={isActive ? '0 0 5.9px 0 #EBEBEB inset, 0 5px 10.5px 0 #F28CA7 inset' : ''}
						_hover={{ bg: bg }}
					>
						{typeof children === 'function' ? children(item, isActive, color) : children}
					</Button>
				);
			})}
		</Flex>
	);
};

export default OptionTabList;
